import React, { Fragment, useState } from "react";
import { Card, CardBody } from "reactstrap";
import DefaultButton from "Components/Buttons/DefaultButton";
import { resultIcon } from "Pages/Melder/WeekReport/utils";
import { useLocation, useNavigate } from "react-router";
import MentionInput from "../../../../../Components/MentionInput/index.js";
import TextLimit from "Api/TextLimit";
import { useAbsentMentionUsers, useUpdateWeekstaatSchool } from "Api/Melder/WeekReport/Show/index.js";

const WeekReportForm = ({ reportData }) => {
  const [selectValue, setSelectValue] = useState("");
  const [text, setText] = useState(null);
  const [textError, setTextError] = useState("");

  const navigate = useNavigate();
  const { state } = useLocation();

  const { data: absentsResponse } = useAbsentMentionUsers(
    reportData?.schoolId,
    reportData?.communityId
  );

  const { trigger: updateWeekstaatSchool } = useUpdateWeekstaatSchool(state?.wsId);

  const absentsData =
    absentsResponse?.data?.map((element) => ({
      ...element,
      name: TextLimit.AfwezigeLimitOptionOne(
        element.vFirstName,
        element.vMiddleName,
        element.vLastName
      ),
    })) || [];

  const sanitizeMessage = (text = "") => {
    return String(text)
      .replace(/\[([^\]]+)\]/g, "$1")
      .replace(/@@(\d+)\|([^@]+)@@/g, "@$2")
      .replace(/\n+/g, " ")
      .replace(/(@[^\s]+)\s+@/g, "$1 @")
      .replace(/^\s+|\s+$/g, "")
      .replace(/\s+$/, "")
      .trim();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectValue) {
      setTextError("Selecteer een van de opties.");
      return;
    }

    if (selectValue === "2" && !text) {
      setTextError("Het veld 'Weigerbericht' is verplicht.");
      return;
    }

    setTextError("");

    const cleanedText = sanitizeMessage(text);

    const msg = {
      declineMessage: cleanedText,
      accepted: Number(selectValue),
    };

    try {
      await updateWeekstaatSchool({
        data: msg,
      });

      navigate("/weekstaat");
    } catch (error) {
      console.error(error);
    }
  };

  if (!reportData) return null;

  return (
    <Fragment>
      <Card className="main-card mb-3">
        <CardBody className="p-3 weekstat-data card-scrollbar-weekstat-melder">
          <form onSubmit={handleSubmit}>
            <h6 className="text-blue mb-4">Weekstaat beoordelen</h6>

            <div className="row">
              <div className="col-6 mb-3 fw-b">Status weekstaat</div>
              <div className="col-6 mb-3">
                {reportData.status ? resultIcon(reportData.status) : "--"}
              </div>

              {reportData.status === "Openstaand" && (
                <>
                  <div className="col-6 mb-3 fw-b">Beoordelen</div>
                  <div className="col-6 d-flex justify-content-end selectBy mb-3">
                    <select
                      className="form-select"
                      style={{ width: "160px" }}
                      value={selectValue}
                      onChange={(event) => {
                        setSelectValue(event.target.value);
                        setTextError("");
                      }}
                    >
                      <option value="">Selecteer keuze</option>
                      <option value="1">Goedkeuren</option>
                      <option value="2">Afkeuren</option>
                    </select>
                  </div>
                </>
              )}

              {selectValue === "2" && (
                <div className="">
                  <p className="mb-1">Geef toelichting op reden van afkeur</p>
                  <div className="w-100 border border-2 p-2">
                    <MentionInput
                      value={text || ""}
                      onChange={(newValue) => {
                        setText(newValue);
                        setTextError("");
                      }}
                      absentsData={absentsData || []}
                      placeholder={
                        "Voer hier uw opmerking in\nTyp @ om een gebruiker te vermelden"
                      }
                    />
                  </div>
                </div>
              )}
            </div>

            {reportData.status !== "Openstaand" && (
              <div className="row res">
                <div className="col-6 mb-3">Beoordeeld door</div>
                <div className="col-6 mb-3 fw-b">{reportData?.acceptedBy}</div>

                <div className="col-6 mb-3">Datum beoordeling</div>
                <div className="col-6 mb-5 fw-b">
                  {reportData?.acceptedDate || "--"}
                </div>

                <div className="col-12 mb-3 fw-b">Afgemeld</div>
                <div className="col-6 mb-3">Afgemeld door</div>
                <div className="col-6 mb-3 fw-b">{reportData?.cloosedBy}</div>

                <div className="col-6 mb-3">Datum afmelding</div>
                <div className="col-6 mb-4 fw-b">
                  {reportData?.cloosedDate || "---"}
                </div>
              </div>
            )}

            {reportData.status === "Afgekeurd" && (
              <div className="row ">
                <div className="col-12 fw-b">Memotext</div>
                <div className="col-12">{reportData?.note}</div>
              </div>
            )}

            {textError && <p className="text-danger">{textError}</p>}

            {reportData.status === "Openstaand" && (
              <div className="text-center mt-3">
                <DefaultButton className="btn-color-style" type="submit">
                  Toepassen
                </DefaultButton>
              </div>
            )}
          </form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default WeekReportForm;